const characters = '0123456789ABCDEFGHIGKLMNOPQRSTUVWXYZ'

export const generateString = (length: number) => {
  let result = ' '
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

export const roundNumber = (val?: number, to?: number) => {
  return val ? Number(val?.toFixed(to ?? 2)) : 0
}
